import { differenceInMonths } from 'date-fns';

export function calculateRecurrenceDuration(start, end) {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const monthDifference = differenceInMonths(endDate, startDate);
  return monthDifference;
}
